import { useMemo } from 'react';

import { useRecoilValue } from 'recoil';

import { useInboundFaxes } from 'lib/hooks/queries/fax/useInboundFaxes';

import practiceState from 'components/practice/practiceState';
import AgTablePage from 'components/shared/AgTablePage/AgTablePage';

import DocumentFaxModal from '../OutboundFaxes/DocumentFaxModal';

import ButtonActions from './components/ButtonActions';
import { DEFAULT_FILTERS, getColDefs } from './configs';

const NewInboundFaxes = () => {
  const currPractice = useRecoilValue(practiceState.currentPractice);
  const timezone = currPractice?.timezone;

  const columnDefs = useMemo(() => getColDefs({ timezone }), [timezone]);

  return (
    <AgTablePage
      ModalComponent={DocumentFaxModal}
      defaultFilters={DEFAULT_FILTERS}
      defaultColumns={columnDefs}
      name="inbound_faxes"
      queryKey="inboundFaxes"
      title="Inbound Faxes"
      disabledCells={['tagLinks']}
      useData={useInboundFaxes}
      rowStyle={{ cursor: 'pointer' }}
      actions={ButtonActions}
      noNewButton
    />
  );
};

export default NewInboundFaxes;
